interface Props {
  activeColor: string;
}
const SingleAiIcon = (props: Props) => {
  const activeColor = props.activeColor ? props.activeColor : "#0f1560";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2L13.8 8.2L20 10L13.8 11.8L12 18L10.2 11.8L4 10L10.2 8.2L12 2Z"
        fill="#22C55E"
      />
    </svg>
  );
};

export default SingleAiIcon;
